
import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapGetters({
      previewMode: 'previewMode'
    })
  }
})
export default class SitePreview extends Vue {
  previewMode!: string
  siteurl: string | null = null
  siteid: string | null = null

  get missingQueryParam (): string | null {
    if (!this.siteurl?.trim()) return 'siteurl'
    if (!this.siteid?.trim()) return 'siteid'
    return null
  }

  get siteUrl (): string | null {
    if (!this.siteurl) return null

    const raw = this.siteurl.trim()
    if (!raw) return null

    // Allow any preview URL as long as it's clearly a Mono URL.
    if (!raw.toLowerCase().includes('mono')) return null

    const hasProtocol = raw.startsWith('https://') || raw.startsWith('http://')
    return hasProtocol ? raw : `https://${raw}`
  }

  get previewStyle (): string {
    return `${this.previewMode}-iframe-container`
  }

  beforeMount (): void {
    const rawSiteurl = this.$route.query.siteurl
    this.siteurl = typeof rawSiteurl === 'string' ? rawSiteurl : null

    const rawSiteid = this.$route.query.siteid
    this.siteid = typeof rawSiteid === 'string' ? rawSiteid : null

    this.$store.dispatch('setSiteButtons', true)
  }

  beforeDestroy (): void {
    this.$store.dispatch('setSiteButtons', false)
  }
}
